import { render, staticRenderFns } from "./PlainGoldSpot.vue?vue&type=template&id=c303e15e&scoped=true&"
import script from "./PlainGoldSpot.vue?vue&type=script&lang=js&"
export * from "./PlainGoldSpot.vue?vue&type=script&lang=js&"
import style0 from "./PlainGoldSpot.vue?vue&type=style&index=0&id=c303e15e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c303e15e",
  null
  
)

export default component.exports